// src/api/wire.ts
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function rowsFromWire(data) {
  const rows = Array.isArray(data) ? data : isRecord(data) ? data.items : void 0;
  return Array.isArray(rows) ? rows.filter(isRecord) : [];
}

export { isRecord, rowsFromWire };
//# sourceMappingURL=chunk-BFUJOKOR.js.map
//# sourceMappingURL=chunk-BFUJOKOR.js.map